import { Convention } from '../../../concepts/objects';
import { Physical } from '../../canvas/entities/Physical';
import { TagLayout } from './TagLayout';

export type LayoutWithTagLayout = { tags: TagLayout };

export interface TagSupport extends Physical {
    readonly layout: LayoutWithTagLayout;
}

export const TagSupport = new Convention<TagSupport>('TagSupport');
